import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { useProgramUpdateMutation } from 'hooks/mutations/content'
import { expManifestRawRoute } from 'pages/NWPlatform/Workspaces/Workspace/ExpManifests/ExpManifest'
import { expManifestQueryKeys } from 'services/queryKeys'

const JSONRaw = () => {
  const { t } = useTranslation(['domain'])
  const { enqueueSnackbar } = useSnackbar()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { expManifestId } = expManifestRawRoute.useParams()

  const expManifestQuery = useQuery(expManifestQueryKeys.detail({ programId: expManifestId }))
  const { data: expManifest } = expManifestQuery

  const { mutate } = useProgramUpdateMutation()

  useEffect(() => {
    if (editorInstanceRef.current && expManifestQuery.isSuccess) {
      editorInstanceRef.current?.getModel()?.setValue(window.JSON.stringify(expManifest, null, 4))
    }
  }, [expManifestQuery.isSuccess, expManifest])

  if (expManifestQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!expManifest) {
    return <NotFound />
  }

  return (
    <Editor
      value={expManifest}
      onSubmit={(data) => {
        mutate(
          {
            programId: expManifestId,
            smepExpManifestEdit: data,
          },
          {
            onSuccess: () => {
              enqueueSnackbar(t('domain:Workspace.ExpManifest.programSaved'), {
                variant: 'success',
              })
            },
          },
        )
      }}
      getEditorInstance={(editorInstance: EditorInstance) => void (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const JSON = memo(JSONRaw)
